import { useMutation } from '@tanstack/react-query';
import { format } from 'date-fns';
import { isNil, omitBy } from 'lodash';
import { getHistoricalRecords } from '../../../shared/services';
import useActiveFiltersStore from '../stores/useActiveFiltersStore';
const useGetHistoricalRecords = () => {
    const queryParams = useActiveFiltersStore((store) => store.activeFilters);
    const { data, isPending, mutate, isError, reset } = useMutation({
        mutationFn: async () => await getHistoricalRecords(
        // omit empty keys
        omitBy({
            ...queryParams,
            dateRangeFrom: queryParams?.dateRangeFrom
                ? format(new Date(queryParams.dateRangeFrom), 'yyyy-MM-dd')
                : null,
            dateRangeTo: queryParams?.dateRangeTo
                ? format(new Date(queryParams.dateRangeTo), 'yyyy-MM-dd')
                : null,
            customerId: queryParams.customerId || undefined,
            officeId: queryParams.officeId?.value || undefined,
            template: queryParams.template?.value || undefined,
            isSent: typeof queryParams.isSent === 'boolean'
                ? +queryParams.isSent
                : undefined,
        }, isNil)),
    });
    return { data, mutate, isLoading: isPending, isError, reset };
};
export default useGetHistoricalRecords;
